import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import blogData from '../data/blog.json';

const Blog = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page-blog">
      <section className="blog-hero">
        <div className="blog-hero-container">
          <h1 className="page-title">{t('blog.pageTitle')}</h1>
          <p className="page-subtitle">
            {t('blog.pageSubtitle')}
          </p>
        </div>
      </section>

      <section className="blog-posts">
        <div className="blog-container">
          <div className="blog-grid">
            {blogData.map((post) => (
              <article key={post.id} className="blog-card">
                <Link to={`/blog/${post.slug}`} className="blog-card-image">
                  <img src={post.coverImage} alt={post.title} />
                  <div className="blog-card-category">{post.category}</div>
                </Link>
                
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-meta-item">
                      <Calendar size={14} />
                      {new Date(post.date).toLocaleDateString('en-US', { 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })}
                    </span>
                    <span className="blog-meta-item">
                      <Clock size={14} />
                      {post.readTime}
                    </span>
                  </div>
                  
                  <Link to={`/blog/${post.slug}`}>
                    <h2 className="blog-card-title">{post.title}</h2>
                  </Link>
                  
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  
                  <Link to={`/blog/${post.slug}`} className="blog-read-more">
                    {t('blog.readMore')}
                    <ArrowRight size={16} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;